export function checkVideoUrl(url: string): boolean {
  const videoFileType = ['mp4', 'move', 'ogg', 'avi', 'wmv', 'flv', 'webm', 'm4v'];
  const urlSplit = url.split('.');
  let fileType = urlSplit[urlSplit.length - 1];
  // TODO: check ?size= then remove it
  if (fileType.includes('?size=')) {
    fileType = fileType.replace(/\?size=\d+/, '');
  }
  return videoFileType.includes(fileType);
  return false;
}
